'use client';

var translations = {
    'my-profile': 'ho-so',
    Close: 'Đóng',
    'Import from LinkedIn': 'Nhập hồ sơ từ LinkedIn',
    'Import profile': 'Nhập hồ sơ',
    'Import again': 'Nhập lại',
    'Open LinkedIn': 'Đăng nhập LinkedIn',
    'Now upload your LinkedIn profile': 'Bây giờ tải lên hồ sơ LinkedIn của bạn',
    'Drag your file here': 'Kéo hồ sơ của bạn vào đây',
    'Or you can': 'Hoặc bạn có thể',
    'Choose file to upload': 'Chọn hồ sơ từ máy bạn',
    '.pdf files that are less than 5120KB in size': 'Hỗ trợ định dạng pdf có kích thước dưới 5120KB',
    'You can attach .pdf file that is less than 5120 KB in size.': 'Vui lòng chọn tập tin đính kèm với định dạng .pdf nhỏ hơn 5120KB.',
    'Profile imported:': 'Hồ sơ đã nhập:',
    'File uploading': 'Đang tải tệp hồ sơ lên',
    'Save time by importing your existing LinkedIn profile!': 'Tiết kiệm thời gian bằng cách nhập hồ sơ LinkedIn hiện có của bạn!',
    'Your LinkedIn profile has been updated to VietnamWorks’s profile successfully.': 'Hồ sơ trên Linkedln của bạn đã được cập nhật thành công lên hồ sơ của VietnamWorks.',
    'Go to': 'Đi tới',
    'My Profile': '"Hồ sơ của tôi"',
    'to review your updated profile.': 'để xem lại hồ sơ cập nhật của bạn.',
    'You can attach .pdf files that are less than 5120KB in size.': 'Vui lòng chọn tập tin đính kèm với định dạng .pdf nhỏ hơn 5120KB.',
    'Something went wrong. Can not import data, please try again.': 'Có lỗi xảy ra không thể tự động điền dữ liệu. Vui lòng thử lại.',
    'It may take a few minutes to import the data...': 'Có thể mất vài phút để nhập dữ liệu ...',
    'Your VietnamWorks profile information will be replaced with information from your LinkedIn account. For example skills, education, experience, etc. and you cannot undo.': '	Thông tin hồ sơ VietnamWorks sẽ được thay thế bằng thông tin từ tài khoản LinkedIn của bạn. Ví dụ: kỹ năng, học vấn, kinh nghiệm,… và bạn không thể hoàn tác.',
    'Save your LinkedIn profile as a': 'Đăng nhập vào tài khoản LinkedIn. Chọn',
    'PDF and upload it ': 'More → Save to PDF',
    'to VietnamWorks. Click the': '. Sau đó,',
    '"More..."': 'tải tệp PDF',
    'button on your LinkedIn profile.': 'lên VietnamWorks.',
    'Profile upload successful': 'Tải hồ sơ lên thành công',
    'Review profile': 'Xem lại hồ sơ',
    "Your LinkedIn profile has been updated to VietnamWorks's profile successfully.": 'Hồ sơ LinkedIn của bạn đã được cập nhật thành công trên VietnamWorks.'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
